import React from "react";

const SearchBar = ({
  searchTerm,
  setSearchTerm,
  placeholder = "Search...",
}) => {
  return (
    <input
      type="text"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      placeholder={placeholder}
      className="block w-full px-4 py-2 text-sm rounded-md border border-gray-300 dark:border-gray-600 
                 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 
                 placeholder-gray-400 dark:placeholder-gray-500 
                 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400 
                 transition duration-200"
    />
  );
};

export default SearchBar;
